import {Prompt} from 'react-router-dom'

const NavigationPrompt = Prompt

export default NavigationPrompt
